const principalStore = (apiServices => ({
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    agentsForPrincipal: [],
    allLeadsListForPrincipal: [],
  },
  mutations: {
    setAgentsForPrincipal: (state, Obj) => {
      state.agentsForPrincipal = Obj; // eslint-disable-line no-param-reassign
    },
    resetLeadsListForPrincipal: (state) => {
      state.allLeadsListForPrincipal = []; // eslint-disable-line no-param-reassign
    },
    addLeadsToListForPrincipal: (state, Obj) => {
      state.allLeadsListForPrincipal = state.allLeadsListForPrincipal.concat(Obj); // eslint-disable-line no-param-reassign
    },
  },
  actions: {
    async loadAgentsForPrincipal(context, userKey) {
      return apiServices.oa.user.getAgentsForPrincipal(userKey)
        .then((agents) => {
          if (agents) {
            const sortedAgents = agents.sort((a, b) => {
              if (a.FullName < b.FullName) { return -1; }
              if (a.FullName > b.FullName) { return 1; }
              return 0;
            });
            context.commit('setAgentsForPrincipal', sortedAgents);
            context.dispatch('loadLeadsList', sortedAgents);
          }
        }, (err) => {
          console.log(err);
        });
    },
    loadLeadsList(context, agents) {
      context.commit('resetLeadsListForPrincipal');
      for (let i = 0; i < agents.length; i += 1) {
        apiServices.oa.leadAgent.getLeadsForAgent(agents[i].Key)
          .then((leadsList) => {
            const list = [];
            for (let i = 0; i < leadsList.leadagentmappingsinfo.length; i += 1) {
              const { lam } = leadsList.leadagentmappingsinfo[i];
              lam.leadinfo = leadsList.leadagentmappingsinfo[i].leadinfo;
              list.push(lam);
            }
            context.commit('addLeadsToListForPrincipal', list);
          });
      }
    },
    refreshLeadAgentMappingInList({ commit }, payload) {
      if (payload.leadsList) {
        // Find the LAM from the leads list and replace its info in the list
        for (let i = 0; i < payload.leadsList.length; i += 1) {
          if (payload.leadsList[i].id === payload.lam.id) {
            // LAM updates do not return leadinfo
            // so let's save the existing one in the updated LAM object
            payload.lam.leadinfo = payload.leadsList[i].leadinfo; // eslint-disable-line no-param-reassign
            payload.leadsList[i] = payload.lam; // eslint-disable-line no-param-reassign
          }
        }
        commit('resetLeadsListForPrincipal');
        commit('addLeadsToListForPrincipal', payload.leadsList);
      }
    },
  },
  getters: {
    agentFilterList: (state) => {
      const agentsList = [{ value: null, text: 'All Agents', selected: false }];

      if (state.agentsForPrincipal) {
        // eslint-disable-next-line no-restricted-syntax
        for (const agent of state.agentsForPrincipal) {
          agentsList.push({ value: agent.Key, text: agent.FullName, selected: false });
        }

        // need to sort by fullname
      }

      return agentsList;
    },
    isPrincipalForAgent: state => (agentKey) => {
      if (state.agentsForPrincipal) {
        return !!(state.agentsForPrincipal.find(agent => agent.Key === agentKey));
      }
    },
  },
}));

export default principalStore;
